enum PublicationMetadataTypeEnum {
    COMMITTEES = "committees",
    ORIGINS = "origins",
    TRANSLATIONS = "translations",
}

export default PublicationMetadataTypeEnum;
